export default "__VITE_ASSET__C$GMBbP9__"